module.exports = __webpack_public_path__ + "static/media/obesity.447bfbde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lsc/obesity.svg
// module id = 438
// module chunks = 0